module.exports = __webpack_public_path__ + "img/ddwu_detail.4428d019.jpg";